















import Table from '@/components/Table/Index.vue';
import MaintenanceData from '@/data/MaintenanceData';
import MaintenanceBody from '@/components/Table/MaintenenceBody.vue';
import {
  Component, Mixins,
} from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import MaintenanceModule from '@/store/modules/Maintenance';
import { IMaintenance, ISwitchGames, IMaintenanceAll } from '@/interface/Mainternance';
import ToolMixin from '@/mixins/Tool.vue';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import GeneralModule from '@/store/modules/General';

@Component({
  components: {
    MaintenanceBody,
    Table,
  },
})
export default class Maintenance extends Mixins(
  ToolMixin, ErrorHandleMixin,
) {
  TableHeadMaintenance = MaintenanceData.TableHeadMaintenance

  dataList: IMaintenance = {
    _id: '',
    backLink: '',
    code: 0,
    maintenanceFlag: false,
    partner: '',
  }

  MaintenanceInstance = getModule(MaintenanceModule, this.$store);

  GeneralInstance = getModule(GeneralModule, this.$store);

  created() {
    this.partnerStatus();
  }

  async partnerStatus() {
    this.GeneralInstance.toggleLoading(true);
    const { data , status } = await this.MaintenanceInstance.FetchGameStatus();
    this.dataList = data.list;
    this.checkError(status);
    this.GeneralInstance.toggleLoading(false);
  }

  async switchGame(partnerCode: number, isCurrentFlag: boolean) {
    if (partnerCode !== 0) {
      const params: ISwitchGames = {
        code: partnerCode,
        flag: !isCurrentFlag,
      };
      const { status } = await this.MaintenanceInstance.SwitchGameStatus(params);
      if (status.code) return this.checkError(status);
      await this.partnerStatus();
    } else {
      const params: IMaintenanceAll = {
        flag: !isCurrentFlag,
      };
      const { status } = await this.MaintenanceInstance.MaintenanceAll(params);
      if (status.code) return this.checkError(status);
      await this.partnerStatus();
    }
  }
}
